export const TEMP_USER_KEY = 'user_id'
export const EXPIRE_ANONIM_DATE = 'expire_date'
export const _MAXIMUI_UPLOAD_IMG = 50
